import omit from 'platform/utilities/data/omit';
import {
  titleUI,
  checkboxGroupUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import {
  SERVICE_PAY_TYPE_LABELS,
  CHECKBOXGROUP_HINT_TEXT,
} from '../../constants';
import {
  isMilitaryRetiredPay,
  isTrainingPay,
} from '../../utils/pageDependencies';

export const updateFormData = (_oldData, newData) => {
  if (!newData?.servicePay) return newData;
  const staleWaivers = [];
  if (!isMilitaryRetiredPay(newData)) {
    staleWaivers.push('isWaivingVaBenefitsForMilitaryRetiredPay');
  }
  if (!isTrainingPay(newData)) {
    staleWaivers.push('isWaivingVaBenefitsForTrainingPay');
  }
  const servicePay = omit(staleWaivers, newData.servicePay);
  return servicePay === newData.servicePay
    ? newData
    : { ...newData, servicePay };
};

export default {
  uiSchema: {
    ...titleUI('Type of service pay'),

    'view:servicePayType': checkboxGroupUI({
      title:
        'What type of pay are you receiving now or will receive in the future?',
      required: true,
      labels: {
        'view:militaryRetiredPay': SERVICE_PAY_TYPE_LABELS.militaryRetiredPay,
        'view:trainingPay': SERVICE_PAY_TYPE_LABELS.trainingPay,
      },
      hint: CHECKBOXGROUP_HINT_TEXT,
      errorMessages: {
        required: 'Select at least one option',
      },
    }),
  },
  schema: {
    type: 'object',
    required: ['view:servicePayType'],
    properties: {
      'view:servicePayType': {
        type: 'object',
        properties: {
          'view:militaryRetiredPay': {
            type: 'boolean',
          },
          'view:trainingPay': {
            type: 'boolean',
          },
        },
      },
    },
  },
};
